module.exports = __webpack_public_path__ + "static/media/thankyoubg.e32ecf1a.png";